export enum PopUpType {
	OPT_INT_POP_UP = 'OptInPopUp',
	EXPERIMENT_A_OPT_IN_POP_UP = 'ExperimentAOptInPopUp',
	EXPERIMENT_C_OPT_IN_POP_UP = 'ExperimentCOptInPopUp',
	AUTH_POP_UP = 'AuthPopUp',
}
